var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFavorites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "31px",
    viewBox: "0 0 29 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_favorites") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u7247",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-134, -214)",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.27346,234.973092 L143.200854,237.55119 C142.954681,237.676304 142.653693,237.578167 142.528579,237.331995 C142.480896,237.238176 142.464033,237.131704 142.48039,237.027742 L143.364784,231.406731 C143.389605,231.248979 143.337579,231.088861 143.224775,230.975826 L139.205338,226.948167 C139.010275,226.752705 139.010598,226.436123 139.20606,226.24106 C139.280552,226.16672 139.376602,226.11778 139.48053,226.101211 L145.099722,225.205332 C145.257423,225.18019 145.393628,225.081231 145.466272,224.939018 L148.054729,219.871691 C148.180346,219.625774 148.481534,219.528253 148.72745,219.65387 C148.821171,219.701744 148.897397,219.77797 148.945271,219.871691 L151.533728,224.939018 C151.606372,225.081231 151.742577,225.18019 151.900278,225.205332 L157.51947,226.101211 C157.792168,226.144688 157.977989,226.400998 157.934512,226.673697 C157.917943,226.777625 157.869003,226.873675 157.794662,226.948167 L153.775225,230.975826 C153.662421,231.088861 153.610395,231.248979 153.635216,231.406731 L154.51961,237.027742 C154.56253,237.300529 154.376185,237.556459 154.103399,237.599378 C153.999437,237.615735 153.892965,237.598872 153.799146,237.55119 L148.72654,234.973092 C148.584179,234.900739 148.415821,234.900739 148.27346,234.973092 Z",
    id: "\\u661F\\u5F62"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFavorites);
export default __webpack_public_path__ + "static/media/icon_favorites.55239c2e9dce8d186243744dd9701ab5.svg";
export { ForwardRef as ReactComponent };